/* eslint-disable */
import React, {Fragment, memo, useCallback, useEffect, useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./ChannelPages.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { AppState } from "../../../../root/RootReducer";
import {Program, ProgramDetail} from "../../../../stores/program/model/Program";
import {
  CircularProgress,
  createStyles,
  makeStyles,
  Tab,
  Tabs,
  withStyles,
} from "@material-ui/core";
import {
  GetRecommendProgramList,
  addRecProgram,
  delRecProgram,
} from "../../../../common/homePage/HomePageActions";
import PuiTypography from "../../../../components/elements/PuiTypography";
import { useNavigate, useParams } from "react-router-dom";
import { animateScroll } from "react-scroll";
import ChannelSlideGroup from "../../../../common/components/slide/ChannelSlideGroup";
import ChannelList from "../../../../common/components/ChannelList/ChannelList";
import SlideNextIcon from "../../../../assets/image/SlideNextIcon";
import SlidePrevIcon from "../../../../assets/image/SlideNextIcon";
import { isAdmin } from "../../../../user/User";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import PuiMessage from "../../../../components/widgets/PuiMessage";
import useResponsive from "../../../../common/useResponsive";
import {useQuery} from "@tanstack/react-query";
import {isNil} from "lodash";

function a11yProps(index: any) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

interface StyledTabsProps {
  value: number;
  className: string;
  style?: React.CSSProperties;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
  children?: React.ReactNode; // 添加 children 属性
}

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "var(--red)",
    },
  },
})((props: StyledTabsProps) => (
  <Tabs
    {...props}
    variant="scrollable"
    scrollButtons="on"
    textColor="secondary"
    TabIndicatorProps={{ children: <span /> }}
  />
));

const useStyles = makeStyles(() =>
  createStyles({
    icon: {
      fontSize: "30px",
      cursor: "pointer",
      position: "relative",
      left: "-40px",
      top: "50px",
      color: "var(--red)",
    },
    tabs: {
      minWidth: "50px",
      padding: "6px 12px",
      marginRight: "46px",
      textTransform: "none",
    },
    tabsMobile: {
      minWidth: "50px",
      padding: "6px 12px",
      marginRight: "16px",
      textTransform: "none",
    },
  })
);

function ProgramIndex() {
  const dispatch = useDispatch();
  const { isDesktop, isMobile, isTablet } = useResponsive();
  const match = useParams<{ id: string }>();
  const history = useNavigate();
  const classes = useStyles();
  // ユーザー取得
  const userInfo = useSelector((state: AppState) => (state.user.userInfo));
  // プログラム一覧リスト
  const allProgramListQueryKey = useMemo(() => ["/api/getAllProgram",{
    params:{userId:userInfo?.id}
  }], [userInfo?.id]);
  const {data:allProgramList = [],isFetching,isPending} = useQuery<ProgramDetail[]>({
    queryKey: allProgramListQueryKey,
    enabled:  !!userInfo?.id
  });
  const isLoading = isFetching || isPending;


  const [tabIndex, setTabIndex] = React.useState<number>(0);
  const [showFixBar, setShowFixBar] = React.useState<boolean>(false);

  const initialBarStyle =
    window.innerWidth > 1165
      ? { top: `${window.innerWidth * 0.13 + 150.7}px` }
      : { top: "303.32px" };
  const [barStyle, setBarStyle] = React.useState<React.CSSProperties>(initialBarStyle);

  // const initialDividerStyle =
  //   window.innerWidth > 1165
  //     ? { height: `${window.innerWidth * 0.13 + 72}px` }
  //     : { height: "222.7px" };
  // const [deviderStyle, setDeviderStyle] = React.useState<React.CSSProperties>(initialDividerStyle);

  const { recommendProgramList } = useSelector(({ recommendList }: AppState) => recommendList);
  const [isLimitRecommendPrograms, ChangeLimitRecommendPrograms] = React.useState(false);

  const [programTitle, setProgramTitle] = React.useState("");
  const [showAddMsg, setShowAddMsg] = React.useState(false);
  const [showDelMsg, setShowDelMsg] = React.useState(false);

  const { data:programList = [] } = useQuery<Program[]>({
    queryKey:['/api/getLearningProgramVideoList',null,userInfo.id],
    enabled: !isNil(userInfo?.id)
  })

  //受講中プログラム（isLearning === true）
  const attendProgram: Program[] =
    programList &&
    programList.filter &&
    programList.filter((row) => {
      return row.isLearning === true;
    });

  //APIコール
  useEffect(() => {
    if (userInfo) {
      dispatch(GetRecommendProgramList(userInfo.id));
    }
  }, [dispatch, userInfo]);

  // ヘッダー
  const { header } = useSelector((state: AppState) => ({
    header: state.header,
  }));
  const direction = header.direction === "left" ? -1 : 1;

  useEffect(() => {
    const { id } = match;

    if (allProgramList.length > 0) {
      let index = 0;
      for (const program of allProgramList) {
        if (program.id === id) {
          setTabIndex(index);
          animateScroll.scrollTo(0, {
            duration: 400,
            smooth: true,
          });

          break;
        }
        index = index + 1;
      }
    }
  }, [match, allProgramList]);

  const scrollChange = (event: React.ChangeEvent<{}>, index: number) => {
    setTabIndex(index);
    const channelList = document.getElementById("channelList");
    const width = window.innerWidth;
    const listHeight = channelList !== null ? channelList.offsetHeight - 1 : 0;
    const scrollBase = width > 1165 ? width * 0.14 + 67.87 : 231;
    console.log(listHeight);

    animateScroll.scrollTo(scrollBase + listHeight * index, {
      duration: 400,
      smooth: true,
    });
  };

  const handleScroll = useCallback(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const width = window.innerWidth;
    const boundaryTop = width * 0.13 + 55.49;
    const scrollBase = width > 1165 ? width * 0.14 + 65.87 : 230;
    const channelList = document.getElementById("channelList");
    const listHeight = channelList !== null ? channelList.offsetHeight - 1 : 0;

    if (scrollTop > boundaryTop) {
      setShowFixBar(true);

      const num = Math.floor((scrollTop - scrollBase) / listHeight);
      setTabIndex(num);
    } else {
      setShowFixBar(false);
      setTabIndex(0);
    }
  }, []);


  useEffect(() => {
    document.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    if (width > 1165) {
      setBarStyle({
        top: `${width * 0.13 + 150.7}px`,
      });
      // setDeviderStyle({
      //   height: `${width * 0.13 + 72}px`,
      // });
    } else {
      setBarStyle({
        top: "303.32px",
      });
      // setDeviderStyle({
      //   height: "222.7px",
      // });
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  // 受講中チャンネル選択
  const handleSelectChannel = (id: string) => {
    if (allProgramList.length > 0) {
      let index = 0;
      for (const program of allProgramList) {
        if (program.id === id) {
          setTabIndex(index);
          animateScroll.scrollTo(0, {
            duration: 400,
            smooth: true,
          });

          //window.historyState(null, "", "/#/channel/" + allProgramList[index].id);
          history("/channel/" + allProgramList[index].id);
          break;
        }
        index = index + 1;
      }
    }
  };

  if (isLoading) {
    return (
      <div className={styles.noContent}>
        <CircularProgress size={60} style={{ color: "var(--red)" }} />
      </div>
    );
  }

  const handleDelRec = (id: number | string, title: string) => {
    if (userInfo) dispatch(delRecProgram(id, userInfo.id));
    setProgramTitle(title);
    setShowAddMsg(false);
    setShowDelMsg(true);
    // TODO
    if (userInfo) setTimeout(() => dispatch(GetRecommendProgramList(userInfo.id)), 1000);
  };

  const handleAddRec = (id: number | string, title: string) => {
    const recommendProgramCount = Object.keys(recommendProgramList)?.length ?? 0;
    if (recommendProgramCount < 3) {
      if (userInfo) dispatch(addRecProgram(id, userInfo.id));
      setProgramTitle(title);
      setShowAddMsg(true);
      setShowDelMsg(false);
      // TODO
      if (userInfo) setTimeout(() => dispatch(GetRecommendProgramList(userInfo.id)), 1000);
    } else {
      ChangeLimitRecommendPrograms(true);
    }
  };

  const closeMsg = () => {
    setProgramTitle("");
    setShowAddMsg(false);
    setShowDelMsg(false);
  };

  const CloseLimitRecommendProgramsBar = () => {
    ChangeLimitRecommendPrograms(false);
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ x: 300 * direction, opacity: 0.3 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -300 * direction, opacity: 0 }}
        className={styles.root}
      >
        <>
          <div className={styles.learningPrograms}>
            <div className={styles.learningTitle}>
              <PuiTypography size={isMobile ? 16 : 20} bold={true}>
                受講中Channel
              </PuiTypography>
            </div>
            <div
              className={`swiper-channel-next-${a11yProps} swiper-channel-next swiper-button-disabled`}
            >
              <div className={styles.swiperButton}>
                <SlideNextIcon />
              </div>
            </div>
            <div
              className={`.swiper-channel-prev-${a11yProps} swiper-channel-prev swiper-button-disabled`}
            >
              <div className={styles.swiperButton}>
                <SlidePrevIcon />
              </div>
            </div>
            <div className={styles.learningGroup}>
              <ChannelSlideGroup
                id="受講Channel"
                ChannelList={attendProgram}
                displayNum={isMobile ? 2 : isTablet ? 3 : 5}
                needLoop={false}
                onCallback={handleSelectChannel}
              />
            </div>
          </div>
        </>
        {showFixBar && (
          <StyledTabs
            value={tabIndex}
            onChange={scrollChange}
            className={styles.fixtabs}
            aria-label="Fix Tabs"
          >
            {allProgramList.length > 0 &&
              allProgramList.map((row, index) => (
                <Tab
                  label={<b>{row.title}</b>}
                  key={row.id}
                  className={isMobile ? classes.tabsMobile : classes.tabs}
                  wrapped={true}
                  {...a11yProps(index)}
                />
              ))}
          </StyledTabs>
        )}
        <StyledTabs
          value={tabIndex}
          onChange={scrollChange}
          className={styles.tabs}
          style={barStyle}
          aria-label="Scroll Tabs"
        >
          {allProgramList.length > 0 &&
            allProgramList.map((channel, index) => (
              <Tab
                key={channel.id}
                label={<b>{channel.title}</b>}
                className={isMobile ? classes.tabsMobile : classes.tabs}
                wrapped={true}
                {...a11yProps(index)}
              />
            ))}
        </StyledTabs>

        {allProgramList.length > 0 &&
          allProgramList.map((channel) => (
            <Fragment key={channel.id}>
              {recommendProgramList.filter((rec) => rec.id === channel.id).length <= 0 &&
                isAdmin(userInfo?.roles) && isDesktop && (
                  <LibraryAddIcon
                    className={classes.icon}
                    style={{ marginBottom: "-28px" }}
                    onClick={() => handleAddRec(channel.id, channel.title)}
                  />
                )}
              {recommendProgramList.filter((rec) => rec.id === channel.id).length > 0 &&
                isAdmin(userInfo?.roles) && isDesktop && (
                  <RemoveCircleOutlineIcon
                    className={classes.icon}
                    style={{ marginBottom: "-27px" }}
                    onClick={() => handleDelRec(channel.id, channel.title)}
                  />
                )}

              <div id="channelList">
                <ChannelList channel={channel} onCallback={handleSelectChannel} />
              </div>
            </Fragment>
          ))}
        <PuiMessage
          open={showAddMsg}
          duration={3000}
          onClose={closeMsg}
          type="success"
          title="おすすめChannelに登録しました。"
          detail={[programTitle]}
        />

        <PuiMessage
          open={showDelMsg}
          duration={3000}
          onClose={closeMsg}
          type="error"
          title="おすすめChannelリストから削除しました。"
          detail={[programTitle]}
        />

        <PuiMessage
          open={isLimitRecommendPrograms}
          duration={3000}
          onClose={CloseLimitRecommendProgramsBar}
          type="error"
          title="おすすめChannelはすでに3件登録されているので追加できません。"
        />
      </motion.div>
    </AnimatePresence>
  );
}

export default memo(ProgramIndex);
